import styles from "./Greeting.module.css";
import ScrollReveal from "../Ui/ScrollReveal";
import {
    FaRegSun,
    FaHubspot,
    FaUsers,
    FaGlobeAsia
  } from "react-icons/fa";
const aboutData = [
    {
        id: 1,
        title: '퍼스널 이미지 &\n컬러 브랜딩 전문',
        description: '사회와 문화의 파트를 반영하는\n감성 이미지 컨설팅'
    },
    {
        id: 2,
        title: '컬러 심리 &\n감성 컬러 프로그램',
        description: '마음 회복, 자기 이해\n콘로 힐링 /자아와 컬러 테라피'
    },
    {
        id: 3,
        title: '컬러 기반\n서비스·공간·식(食) 연구',
        description: '외식산 및 오감 서비스 디자인\n컬러화, 공간, 푸드, 아이덴티티와'
    },
    {
        id: 4,
        title: '감성패턴 전문가 양성과\n커뮤니티 플랫폼',
        description: '강사, 컨설턴트, 테라피스트, 커뮤니티\n운영자 등 다양한 실무 분야의 전문가 배출'
    }
];

const visionItems = [
    {
        id: 1,
        icon: <FaRegSun color="#FFD1DF"/>,
        title: 'Color for Life, Color for People',
        description: '컬러가 삶의 문제를 해결하고 관계를 회복하는 실질적 도구가 되는 미래'
    },
    {
        id: 2,
        icon: <FaHubspot  color="#FFD1DF"/>,
        title: '컬러 기반 감성 산업의 허브',
        description: '교육, 디자인, 브랜딩, 공간, 서비스, 푸드, 테라피 산업을 통합하는 컬러 생태계 구축'
    },
    {
        id: 3,
        icon: <FaUsers  color="#FFD1DF" />,
        title: '회원 중심의 성장 플랫폼',
        description: '한 사람의 성공이 모두의 성공이 되는 공유·협업·상생 구조'
    },
    {
        id: 4,
        icon: <FaGlobeAsia  color="#FFD1DF" />,
        title: '한국의 감성 색채 철학을 세계로',
        description: '한국형 감성 색채 해석을 글로벌 스탠다드로 확장'
    }
];

function Greeting() {
    return (
        <div className={styles.greetingWrap}>
            <ScrollReveal>
                <section className={styles.section01}>
                <div className={styles.imgBox}>
                    <img
                        src="/image/about_company_img01.jpeg"
                        alt="about_company_img01"
                    />
                </div>
                <div className={styles.infoBox}>
                    <div className={styles.infoTitle}>
                        <p className={styles.subtitle}>
                            Greeting
                        </p>
                        <p className={styles.koTitle}>
                            인사말
                        </p>
                    </div>
                    <div className={styles.infoTextBox}>
                        <span>
                            사람은 누구나 자기만의 컬러를 지니고 살아갑니다. 그 컬러는 외모나 취향을 넘어 삶의 방식, 감정, 기억, 관계, 그리고 존재의 빛을 담고 있습니다. 우리는 타인과 연결되는 순간, 서로의 이야기를 바라보고, 듣고, 느끼며 알게 모르게 자신만의 브랜드 이미지를 만들어 갑니다. 그것은 결코 누가 대신 만들어 줄 수 없는, 그리고 나의 동의 없이 완성될 수 없는 고유한 스토리입니다. 한국감성색채협회는 바로 그 지점을 지향합니다. 누군가의 이미지를 평가하는 협회가 아니라, 각자의 컬러와 가치를 발견하고 빛나도록 돕는 협회. 사회 속에서, 관계 속에서, 일상 속에서 ‘나답게 살아가는 컬러’를 찾는 사람들과 함께하고자 합니다.
                        </span>
                        <span>
                            찾고 배우고 성장하면서, 서로를 지지하고 기쁨을 나누는 상생의 플랫폼이 되고자 합니다.
                            당신의 존재는 이미 충분히 아름답습니다. 우리는 단지, 그것이 ‘보이도록’ 함께 할 뿐입니다.
                        </span>
                        <p>
                            한국감성색채협회 <span>회장 김 옥 기</span>
                        </p>
                    </div>
                </div>
            </section>
            </ScrollReveal>
            <ScrollReveal>
                <section className={styles.section02}>
                <div className={styles.titleWrap}>
                    <p className={styles.subtitle}>About us</p>
                    <h2 className={styles.title}>
                        협회 소개
                    </h2>
                    <div className={styles.line}></div>
                </div>
                <div className={styles.aboutIntro}>
                    <p className={styles.aboutIntroText}>
                        한국감성색채협회는 의식주 모든 면에 관련이 깊게 얽힌 컬러를 탐구·교육·확산하는 공식 전문 협회입니다.
                    </p>
                    <p className={styles.aboutIntroText}>
                        컬러를 단지 아름다운 취향의일이 아니라, 삶을 움직이고 마음을 열도하며 관계를 찾아내는 감성 언어로 바라봅니다.
                    </p>
                </div>
                <div className={styles.aboutDesc}>
                    우리의 활동 영역은 다음과 같습니다.
                </div>
                <div className={styles.aboutBox}>
                    {aboutData.map((item) => (
                        <div key={item.id} className={styles.aboutBoxItem}>
                            <div className={styles.aboutBoxHeader}>
                                <div className={styles.aboutBoxNumber}>{`0${item.id}`}</div>
                            </div>
                            <div className={styles.aboutBoxContent}>
                                <h3 className={styles.aboutBoxTitle}>
                                    {item.title.split('\n').map((line, index) => (
                                        <span key={index}>
                                            {line}
                                            {index < item.title.split('\n').length - 1 && <br />}
                                        </span>
                                    ))}
                                </h3>
                                <p className={styles.aboutBoxDesc}>
                                    {item.description.split('\n').map((line, index) => (
                                        <span key={index}>
                                            {line}
                                            {index < item.description.split('\n').length - 1 && <br />}
                                        </span>
                                    ))}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className={styles.aboutBottom}>
                    <p className={styles.aboutBottomText}>
                        한국감성색채협회는 회원 한 사람 한 사람이 주체가 되는 구조,
                    </p>
                    <p className={styles.aboutBottomText}>
                        함께 배우고 성장하며 지속 가능한 상생 생태계를 만드는 데 최우선 가치를 둡니다.
                    </p>
                </div>
            </section>
            </ScrollReveal>
            <ScrollReveal>
                <section className={styles.section03}>
                <div className={styles.titleWrap}>
                    <p className={styles.subtitle}>Vision</p>
                    <h2 className={styles.title}>
                        비전
                    </h2>
                    <div className={styles.line}></div>
                </div>
                <div className={styles.visionIntro}>
                    <p className={styles.visionIntroText}>
                        우리는 컬러가 인간의 삶을 바꾸는 힘을 믿습니다.
                    </p>
                    <p className={styles.visionIntroText}>
                        그 힘은 강요가 아니라 공감에서 시작되고, 경쟁이 아니라 상생에서 꽃피며, 이론이 아니라 사람 안에서 증명됩니다.
                    </p>
                </div>
                <div className={styles.visionSubtitle}>
                    한국감성색채협회의 비전은 다음과 같습니다:
                </div>
                <div className={styles.visionGrid}>
                    {visionItems.map((item) => (
                        <div key={item.id} className={styles.visionCard}>
                            <div className={styles.visionCardIcon}>{item.icon}</div>
                            <h3 className={styles.visionCardTitle}>{item.title}</h3>
                            <p className={styles.visionCardDesc}>{item.description}</p>
                        </div>
                    ))}
                </div>
                <div className={styles.visionClosing}>
                    <p className={styles.visionClosingText}>
                        우리는 '컬러를 잘 아는 사람들'이 아니라<br />
                        컬러로 세상 속에서 마음과 삶을 더 따뜻하게 만드는 사람들이 모이는 협회가 되고자 합니다.
                    </p>
                    <p className={styles.visionClosingText}>
                        누군가의 삶에 빛을 비추는 사람들. 그 빛이 다시 또 다른 사람의 내일을 비추는 선순환.<br />
                        그것이 한국감성색채협회의 궁극적인 존재 이유입니다.
                    </p>
                </div>
            </section>
            </ScrollReveal>
        </div>
    )
}

export default Greeting;